module.exports = __webpack_public_path__ + "52b54fca19364c789fbf860ad4f6e8ad.jpg";